<template>
  <div>
    <MediaContainer
      onlyThumbnails
      smallThumbnails
      slot="left"
      :readOnly="loading"
      :images="response"
      @change="$emit('change', $event)"
    />
    <div class="mt-n3">
      <span
        class="red--text text--accent-2 caption ml-3 "
        v-if="!isImageValid"
        >{{ $t('validation.form.required_question') }}</span
      >
    </div>
  </div>
</template>

<script>
import MediaContainer from '@/components/MediaContainer/MediaContainer.vue'

export default {
  name: 'ImageForm',

  components: {
    MediaContainer,
  },

  props: {
    response: {
      type: Array,
      required: false,
    },
    loading: Boolean,
    isImageValid: {
      type: Boolean,
      default: () => true,
    },
  },
}
</script>
